import apiClient from '../utils/apiClient';

/**
 * Custom field DEFINITIONS for a facility (customer / unit / rental).
 *
 * Rewritten 2026-07-19: this called a bare `/api/custom-fields` with raw axios
 * and a hand-attached token. That endpoint never existed, so every call 404'd
 * and the whole feature was inert. It is now facility-scoped like every other
 * operational route, and goes through apiClient so auth + refresh are handled
 * the same way as the rest of the app.
 */
const base = (facilityId) => `/api/facilities/${facilityId}/custom-fields`;

const customFieldsService = {
  // entity: 'customer' | 'unit' | 'rental' (omit for all)
  getAll: (facilityId, entity) =>
    apiClient.get(`${base(facilityId)}/`, {
      params: entity ? { entity } : undefined,
    }),
  getById: (facilityId, fieldId) =>
    apiClient.get(`${base(facilityId)}/${fieldId}`),
  create: (facilityId, data) =>
    apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, fieldId, data) =>
    apiClient.put(`${base(facilityId)}/${fieldId}`, data),
  // Values already collected are kept unless purgeValues is true — deleting a
  // definition should not silently destroy data the operator gathered.
  remove: (facilityId, fieldId, purgeValues = false) =>
    apiClient.delete(`${base(facilityId)}/${fieldId}`, {
      params: { purge_values: purgeValues },
    }),
};

export default customFieldsService;
